import React from "react";
import "./eventFilterToggle.css";
import {
  EVENT_FILTER_ALL,
  EVENT_FILTER_PERSONAL,
  EVENT_FILTER_WORK,
} from "../../../../utils/calendarPersonalEvents";

// Personal ("SIX") events, 2026-09-11. Three-state All | Personal | Work filter
// shared by every calendar surface (month / week / 3-day / day). State lives in
// CalendarPage (persisted under `bdr-calendar-event-filter`) and is passed down
// as props; this component is presentation only. At the mobile breakpoint the
// labels collapse to their initials (A | P | W) via CSS — no resize listener.
const OPTIONS = [
  { value: EVENT_FILTER_ALL, full: "All", short: "A" },
  { value: EVENT_FILTER_PERSONAL, full: "Personal", short: "P" },
  { value: EVENT_FILTER_WORK, full: "Work", short: "W" },
];

const EventFilterToggle = ({ value, onChange, className = "" }) => (
  <div
    className={`event-filter-toggle${className ? ` ${className}` : ""}`}
    role="group"
    aria-label="Event filter"
  >
    {OPTIONS.map((opt) => {
      const active = value === opt.value;
      return (
        <button
          key={opt.value}
          type="button"
          className={`calendar-week-btn event-filter-btn${active ? " event-filter-btn--active" : ""}`}
          aria-pressed={active}
          title={opt.full}
          onClick={() => {
            if (!active) onChange?.(opt.value);
          }}
        >
          <span className="event-filter-label-full">{opt.full}</span>
          <span className="event-filter-label-short">{opt.short}</span>
        </button>
      );
    })}
  </div>
);

export default EventFilterToggle;
